import { createContext, type FC, type ReactNode } from "react";

import { type CheckoutV2Configuration, type CheckoutV2ConfigurationBuilder } from "@jti/commerce";

import { prepareShippingMethods } from "./utils/prepareShippingMethods";

export const CheckoutV2ConfigurationContext = createContext<CheckoutV2Configuration | null>(null);

type CheckoutConfigurationProviderProps = {
  children: ReactNode;
  data: CheckoutV2ConfigurationBuilder;
};

export const CheckoutV2ConfigurationProvider: FC<CheckoutConfigurationProviderProps> = ({ children, data }) => {
  const preparedContextValue = { ...data, shippingMethods: prepareShippingMethods(data) };

  return (
    <CheckoutV2ConfigurationContext.Provider value={preparedContextValue}>
      {children}
    </CheckoutV2ConfigurationContext.Provider>
  );
};
